import React from "react";
import CropperPage from './cropper'

const App = () => {
  return(
    <div>
      <CropperPage />
    </div>
  )
}
export default App